import React from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiBriefcase, FiUsers } from "react-icons/fi";
import styles from "./UserTypeModal.module.css";

const UserTypeComponent = ({ onClose }) => {
  const navigate = useNavigate();

  const handleUpdateUserType = (userType) => {
    axios
      .patch(`http://localhost:5000/api/v1/user/type/${userType}`, { userType })
      .then(() => {
        if (onClose) onClose();
        if (userType === "applicant") navigate("/find-jobs");
        else navigate("/hire-employees");
      })
      .catch((error) => {
        console.error("Error updating user type:", error);
        if (onClose) onClose();
        if (userType === "applicant") navigate("/find-jobs");
        else navigate("/hire-employees");
      });
  };

  return (
    <div className={styles.container}>
      <p className={styles.subtitle}>
        Registration complete! Tell us how you'll be using Blockenzyme.
      </p>
      <div className={styles.options}>
        <button
          className={`${styles.optionCard} ${styles.jobSeeker}`}
          onClick={() => handleUpdateUserType("applicant")}
        >
          <div className={styles.optionIcon}>
            <FiBriefcase />
          </div>
          <h4 className={styles.optionTitle}>I'm Looking for Jobs</h4>
          <p className={styles.optionDesc}>Browse thousands of job listings and apply to top companies</p>
        </button>
        <button
          className={`${styles.optionCard} ${styles.employer}`}
          onClick={() => handleUpdateUserType("recruiter")}
        >
          <div className={styles.optionIconPurple}>
            <FiUsers />
          </div>
          <h4 className={styles.optionTitle}>I'm Hiring Talent</h4>
          <p className={styles.optionDesc}>Post jobs and connect with qualified candidates fast</p>
        </button>
      </div>
    </div>
  );
};

export default UserTypeComponent;
